export default __webpack_public_path__ + "static/media/13.684e8d2b.jpg";